import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import MediaList from 'components/partials/MediaList'
import MediaImage from 'components/partials/MediaImage'
import MediaContent from 'components/partials/MediaContent'
import IconArrowRight from 'components/partials/IconArrowRight'
import Description from 'components/partials/Description'
import Breadcrumb from 'components/Breadcrumb'
import { Link } from 'components/Link'
import ViewModeContext from 'contexts/ViewModeContext'
import useClickLogger from 'api/ClickLogger'


function PersonTemplate({ ...doc }) {
  return (
    <ViewModeContext.Consumer>
      {context => context.isTable ? (
        <PersonTable {...doc} />
      ) : (
        <PersonTeaser {...doc} />
      )}
    </ViewModeContext.Consumer>
  )
}

export default PersonTemplate



function PersonTable({
  image_url,
  title,
  url,
  _click,
  affiliations = [],
}) {

  const { trackResultClick } = useClickLogger(_click, url);

  const { t } = useTranslation()
  return (
    <tr onClick={trackResultClick} style={{ cursor: 'pointer' }}>
      <td>
        <div className="media u-align-center">
          {image_url && <MediaImage src={image_url} modifierClasses="thumbnail--square" />}
          <MediaContent>
            <Link modifierClasses="u-hover-underlined" href={url}>
              <span dangerouslySetInnerHTML={{ __html: title }} />
              <IconArrowRight />
            </Link>
          </MediaContent>
        </div>
      </td>
      <td>
        <table className="RS_CONTENT"> {/* NOTE: ReadySpeaker class */}
          <thead>
            <tr className="visually-hidden">
              <th>{t('Organisation')}</th>
              <th>{t('Role')}</th>
              <th>{t('Phone')}</th>
              <th>{t('E-mail')}</th>
            </tr>
          </thead>
          <tbody>
            {affiliations.map(affiliation => (
              <tr>
                <td>
                  {affiliation.organization && (
                    <Description text={affiliation.organization} />
                  )}
                </td>
                <td>
                  {affiliation.affiliation_name && (
                    <Description text={affiliation.affiliation_name} />
                  )}
                </td>
                <td>
                  {affiliation.phone && (
                    <a
                      className="link u-hover-underlined u-text-color-secondary"
                      href={'tel:'.concat(affiliation.phone)}
                    >
                      {affiliation.phone}
                    </a>
                  )}
                  {affiliation.mobile && (
                    <>
                      <br className="rs_pause" style={{ display: 'none' }} /> {/* NOTE: ReadySpeaker class */}
                      <span className="visually-hidden">Mobil:</span>
                      <br className="rs_pause" style={{ display: 'none' }} /> {/* NOTE: ReadySpeaker class */}
                    </>
                  )}
                  {affiliation.mobile && (
                    <a
                      className="link u-hover-underlined u-text-color-secondary"
                      href={'tel:'.concat(affiliation.mobile)}
                    >
                      {affiliation.mobile}
                    </a>
                  )}
                </td>
                <td>
                  {affiliation.email && (
                    <a
                      className="link u-hover-underlined u-text-color-secondary u-word-break"
                      style={{ wordBreak: 'break-word' }}
                      href={'mailto:'.concat((affiliation.email || []).slice(0, 1).shift())}
                    >
                      {(affiliation.email || []).slice(0, 1).shift()}
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </td>
    </tr >
  )
}

function PersonTeaser({
  image_url,
  title,
  url,
  _click,
  affiliations = [],
  __breadcrumb__,
}) {
  const { trackResultClick } = useClickLogger(_click, url);
  return (
    < MediaList onClick={trackResultClick}>
      {image_url && <MediaImage src={image_url} modifierClasses="thumbnail--square" />}
      <MediaContent modifierClasses="u-max-width-full">
        <div>
          <Link href={url}>
            <span dangerouslySetInnerHTML={{ __html: title }} />
            <IconArrowRight />
          </Link>
        </div>
        {affiliations.map(affiliation => (
          <div className="u-block u-inline-block-medium-up u-mr-200 u-mb-50">
            {affiliation.organization && (
              <div className="description description--large u-text-color-secondary">
                {affiliation.organization}
              </div>
            )}
            {affiliation.affiliation_name && (
              <div className="description description--large u-text-color-secondary">
                {affiliation.affiliation_name}
              </div>
            )}
            {affiliation.phone && (
              <div>
                <a
                  className="link u-text-color-secondary u-mt-25"
                  href={'tel:'.concat(affiliation.phone)}
                >
                  {affiliation.phone}
                </a>
              </div>
            )}
            {affiliation.mobile && (
              <div>
                <a
                  className="link u-text-color-secondary u-mt-25"
                  href={'tel:'.concat(affiliation.mobile)}
                >
                  {affiliation.mobile}
                </a>
              </div>
            )}
            {affiliation.email && (
              <div>
                <a
                  className="link u-text-color-secondary u-mt-0125"
                  href={'mailto:'.concat((affiliation.email || []).slice(0, 1).shift())}
                >
                  {(affiliation.email || []).slice(0, 1).shift()}
                </a>
              </div>
            )}
          </div>
        ))}
        <Breadcrumb links={__breadcrumb__} disabled />
      </MediaContent>
    </MediaList >
  )
}
